import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogComponent } from "./../../common/DialogComponent";
import * as ProtectionPlanActions from "../../../store/protectionPlanService/idf/actions";
import IDFProtectionPlanTermsAndCondition from "../../Dialogs/protectionPlan/IDFProtectionPlanTermsAndCondition";
import * as services from "../../../store/service";
import { ApplicationState } from "../../../store";
import { IPackage } from "../../../store/protectionPlanService/idf/types";
import { Notification } from "../../common/Notification";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import BillingInfoIDFUser from "./../BillingInfoIDFUser";
import WhatYouNeedToKnow from "../../common/WhatYouNeedToKnow";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { GetAccountInformation } from "../../../store/service";

interface IProps {
    closeDialog: any;
    dialogId: string;
    packageIndex: number;
    writtenInstructionTimeStamp: any;
    closeUpgradeAndOpenCompletionDialog: any;
}

const MigratedUserPurchasePlan: React.FunctionComponent<IProps> = (props) => {

    const dispatch = useDispatch();
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));

    const { t: tLang } = useTranslation();
    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const [tncDialog, setTncDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [isTermsChecked, setCheckBox] = useState(false);

    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanIdfState && state.protectionPlanIdfState.protectionPlanData) {

            return state.protectionPlanIdfState.protectionPlanData.packageList;
        }
    });

    const checkBoxOnChange = () => {
        if (!isTermsChecked) {
            setCheckBox(true);
            let purchaseAcceptanceTime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
            setPurchaseAcceptanceTime(purchaseAcceptanceTime);
            if (creditCard.cardNumber && creditCard.cardNumber != "") {
                setDisabled(false);
            }
        }
        else {
            setCheckBox(false);
            setDisabled(true);
        }
    };
    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;

    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            setShowBillingInfoDialog(false);
        }
    };
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };


    const [updateRequestData, setUpdateRequest] = useState({
        nukeUserId: 0,
        writtenInstructionAcceptance: "",
        userAcceptance: "",
        purchcaseAcceptance: ""
    })


    const setTimeStamp = (type: any) => {

    }
    const [billingTime, setTime] = useState("");
    const [purchaseAcceptanceTime, setPurchaseAcceptanceTime] = useState("");

    const [creditCard, setcreditCardDetails] = useState({
        cardType: {
            options: [],
            readOnly: true,
        },
        nameOnCard: "",
        cardNumber: "",
        expDateMo: "",
        expDateYr: "",
        securityCode: "",
        billingZip: "",
    });

    const sendBillingData = (creditCardDetails: any) => {
        setcreditCardDetails(creditCardDetails);
        if (isTermsChecked) {
            setDisabled(false);
        }
        let billingAddTime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
        setTime(billingAddTime.toString());
    }

    const handleTncDialog = (value: string): any => {
        if (value === "show") {
            setTncDialog(true);
        } else if (value === "cancel") {
            setTncDialog(false);
        } else if (value === "close") {
            setTncDialog(false);
        }
    };

    const { register, errors, reset, formState, handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const onSubmit = (data: any) => {
        setLoading(true);
        SaveBillingInfo();
    };

    const getSubscriptionType = () => {
        let subscriptionType = "Monthly";
        if (selectedPackage && selectedPackage["billing-cycle"]) {
            subscriptionType = selectedPackage["billing-cycle"];
        }

        return subscriptionType?.toUpperCase();
    };
    const [showDisclosure, setShowDisclosure] = useState(false);
    const showDisclosureStatus = (value: boolean) => {
        setShowDisclosure(value);
    };
    const showErrorNotification = (errors: any[]) => {
        if (errors) {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: errors[0],
                duration: 5,
            });
        } else {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: "Could not save information. Please try again later.",
                duration: 5,
            });
        }
    };

    const dialogTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "Cancel " + selectedPackage.name + " Plan";
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            return "Upgrade to " + selectedPackage.name + " Plan";
        } else {
            return "Purchase Ultra Secure + Individual";
        }
    };

    const submitButtonLabel = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "Cancel Plan";
        } else {
            return selectedPackage?.ActionButtonText;
        }
    };

    const getBillingAmountLabel = () => {
        return "Today's Net Charge";
    };

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => { });
        };

    });

    useEffect(() => {
        loadPaymentInfoData();
        requestProtectionPlan(true);

    }, []);

    const loadPaymentInfoData = () => {
        services.GetPaymentDetail().then((data) => {
            setcreditCardDetails(data.creditCard);
        });
    };

    const SaveBillingInfo = () => {
        const requestBody = {
            creditCardDetails: creditCard,
            updateRequest: {
                writtenInstructionAcceptance: props.writtenInstructionTimeStamp,
                userAcceptance: billingTime,
                purchcaseAcceptance: purchaseAcceptanceTime
            }
        };
        setLoading(true);
        services
            .SaveBillingInfo(requestBody)
            .then((data) => {
                setLoading(false);
                if (data.isSuccess) {
                    Notification({
                        type: "success",
                        title: tLang("manageAccount.protectionPlan.notification.title"),
                        message: "Billing Information Saved Successfully.",
                        duration: 5,
                    });
                    GetAccountInformation().then((data: any) => {
                        dispatch({
                            type: "GET_ACCOUNT_INFORMATION"
                            , _unifiedAccountInfo: data._unifiedAccountInfo,
                        });

                    });
                    props.closeDialog();
                } else if (data.errors && data.errors.length > 0) {
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.title"),
                        message: data.errors[0],
                        duration: 5,
                    });
                    props.closeDialog();
                    window.location.reload();
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: tLang("manageAccount.protectionPlan.notification.title"),
                        message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                        duration: 5,
                    });
                    props.closeDialog();
                    window.location.reload();
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: tLang("manageAccount.protectionPlan.notification.title"),
                    message: tLang("manageAccount.protectionPlan.notification.couldNotSaveInformationMsg"),
                });
                window.location.reload();
            });
    };
    const [serviceListOfSelectedPackage, setServiceListOfSelectedPackage]: any = useState([""]);
    useEffect(() => {
        if (selectedPackage) {
            let serviceCodes = [] as string[];
            selectedPackage.products?.forEach((p) => {
                if (p.serviceCode != null && p.serviceCode !== "" && p.serviceCode !== "--") {
                    serviceCodes.push(p.serviceCode);
                }
            });
            setServiceListOfSelectedPackage(serviceCodes);
        }
    }, [selectedPackage]);

    const closeDialog = () => {
        props.closeDialog();
    }


    return (
        <React.Fragment>

            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>Purchase {selectedPackage?.name}</h1>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={"dialog-body " + (loading ? "loading" : "")}>

                    <div className="form-row">
                        <h3 className="content-sub-title">Your Cart Summary</h3>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row data-grid has-lines row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label font-weight-bold" id="label-selected-plan">
                                        <strong>Your Plan</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-selected-plan">
                                        {selectedPackage?.name}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className={"form-row data-grid row-height-sm " + selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel" ? "has-lines" : ""}>
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-payment-info">
                                        <p>
                                            <strong>Payment Information</strong>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-payment-info">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                {creditCard?.cardNumber ? (
                                                    <p>
                                                        {creditCard?.nameOnCard && (
                                                            <span>
                                                                {creditCard?.nameOnCard}
                                                                <br />
                                                            </span>
                                                        )}
                                                        <span className="dialog-icon">
                                                            <em className="las la-credit-card inline-icon"></em> {creditCard?.cardNumber}
                                                            <br />
                                                        </span>
                                                        {creditCard?.expDateMo && creditCard?.expDateYr && (
                                                            <span>
                                                                Exp. {[creditCard?.expDateMo, creditCard?.expDateYr].join("/")}
                                                                <br />
                                                            </span>
                                                        )}
                                                        {creditCard?.billingZip}
                                                    </p>
                                                ) : (
                                                    <div className="msg-generic msg-small margin-top-xs">
                                                        <RenderIcons iconName="info-circle" />
                                                        There is no Payment Profile
                                                        <br />
                                                        associated with your account.
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <span
                                                    className="default_link"
                                                    onClick={(e) => {
                                                        showBillingInformation(e);
                                                        window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                    }}
                                                >
                                                    <a href="javascript:void(0)" className="default_link">
                                                        {creditCard?.cardNumber ? "Change" : "Add"}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {!creditCard?.cardNumber && selectedPackage?.ActionButtonText?.toLowerCase() != "cancel" && (
                                        <div className="data-value">
                                            <input
                                                type="text"
                                                name="cardNumber"
                                                id="label-payment-card-number"
                                                defaultValue={creditCard?.cardNumber}
                                                ref={register({ required: true })}
                                                style={{ opacity: 0, height: 0, width: 0, float: "left" }}
                                            />
                                            {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                                <span className="form-error">Payment information is required</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {selectedPackage?.ActionButtonText?.toLowerCase() == "cancel" && (
                        <React.Fragment>
                            <div className="line-divider margin-vertical-xs"></div>
                            <div className="form-row data-grid row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label font-weight-bold" id="label-selected-plan">
                                                <strong>Plan Cost</strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="label-monthly-charge">
                                                ${Number(selectedPackage?.Price).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                            </div>

                            <div className="form-row data-grid row-height-sm">
                                <WhatYouNeedToKnow serviceList={serviceListOfSelectedPackage} selectedCountry={accountInfo?.country} showDisclosureStatus={showDisclosureStatus} />
                            </div>
                            <div className="msg-generic msg-small margin-top-xs">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-text">
                                            <h2 className="automatic-renewal"> {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.yearly-automatic-renewal") : tLang("registration.billing.renewal-disclosure.monthly-automatic-renewal")}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="margin-bottom-l"></div>
                                <div className="form-row">
                                    <div className="form-input">
                                        <label className="form-checkbox-label">
                                            <input
                                                type="checkbox"
                                                name="isTermsChecked"
                                                checked={isTermsChecked}
                                                onChange={() => checkBoxOnChange()}
                                            />

                                            <>
                                                <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem", paddingTop: "0.3rem" }}>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText1")}
                                                    {selectedPackage.Price ? Number(selectedPackage.Price).toFixed(2) : "0.00"} {tLang("registration.billing.renewal-disclosure.renewalText2")} {" "} {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.an-annual") : tLang("registration.billing.renewal-disclosure.a-monthly")}{" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText3")}
                                                    {selectedPackage.Price ? Number(selectedPackage.Price).toFixed(2) : "0.00"} {tLang("registration.billing.renewal-disclosure.renewalText4")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText5")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.annual") : tLang("registration.billing.renewal-disclosure.monthly")} {tLang("registration.billing.renewal-disclosure.renewalText6")} {" "} {getSubscriptionType() === "YEARLY" ? "date " : "day "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText7")} {" "}
                                                    {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {tLang("registration.billing.renewal-disclosure.renewalText8")} {" "}
                                                    <div className="margin-bottom-l"></div>
                                                    <legend className="legend-label">{tLang("registration.billing.renewal-disclosure.cancellation")}</legend>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText9")} {" "} {partnerPhoneNumber}.
                                                    {tLang("registration.billing.renewal-disclosure.renewalText10")} {" "}
                                                </span>
                                            </>

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-purchase"
                                disabled={disabled}
                                onClick={() => window.addToDataLayer({ event: "Protection Plan - Submit " + selectedPackage?.ActionButtonText?.toUpperCase() })}
                            >
                                <span className="btn-text">Purchase</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="protection-plan-billing-information-dialog"
                    title="Billing Information"
                    datalayerEvent="Protection Plan - Close billing info"
                    closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }}
                >
                    <BillingInfoIDFUser closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }} sendBillingData={sendBillingData}></BillingInfoIDFUser>
                </DialogComponent>
            )}

            {tncDialog && (
                <DialogComponent
                    dialogId="protection-plan-tnc-dialog"
                    title="Terms and Conditions"
                    datalayerEvent="Protection Plan - Close TNC"
                    closeDialog={() => handleTncDialog("close")}
                >
                    <IDFProtectionPlanTermsAndCondition
                        dialogId="protection-plan-tnc-dialog"
                        closeDialog={() => handleTncDialog("close")}
                        packageIndex={props.packageIndex}
                    ></IDFProtectionPlanTermsAndCondition>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};
export default MigratedUserPurchasePlan;
